"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseEndpointOutSerializer = void 0;
const endpointOut_1 = require("./endpointOut");
exports.ListResponseEndpointOutSerializer = {
    _fromJsonObject(object) {
        return {
            data: object["data"].map((item) => endpointOut_1.EndpointOutSerializer._fromJsonObject(item)),
            done: object["done"],
            iterator: object["iterator"],
            prevIterator: object["prevIterator"],
        };
    },
    _toJsonObject(self) {
        return {
            data: self.data.map((item) => endpointOut_1.EndpointOutSerializer._toJsonObject(item)),
            done: self.done,
            iterator: self.iterator,
            prevIterator: self.prevIterator,
        };
    },
};
//# sourceMappingURL=listResponseEndpointOut.js.map